"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _class, _descriptor, _descriptor2, _temp;

var Badge = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Badge, _Component);

  function Badge() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Badge);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Badge)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "rule", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Badge, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_base.default, {
        type: "badge"
      }, _react.default.createElement("div", {
        className: "icon",
        style: {
          backgroundImage: this.item.icon_name ? "url(".concat(this.item.icon_name, ")") : "url(default-images/rewardBadge)"
        }
      }), _react.default.createElement("h2", {
        className: "name"
      }, this.item.name), _react.default.createElement("h2", {
        className: "count"
      }, "Badge"));
    }
  }]);
  return Badge;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rule", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = Badge;